import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { buildOrganizationSchema, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/")({
  head: () =>
    buildSeoHead(publicPageSeo.home, [
      buildOrganizationSchema(),
      buildPageSchema(publicPageSeo.home, "WebPage"),
    ]),
  component: Index,
});
